var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgScoreFrame = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 106,
  height: 106,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 53,
  r: 53,
  fill: "url(#scoreFrame_svg__a)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "scoreFrame_svg__c",
  width: 106,
  height: 106,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 53,
  r: 53,
  fill: "url(#scoreFrame_svg__b)"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#scoreFrame_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0C9BAB",
  d: "M114.509 29.204c22.598 22.598 22.695 59.14.216 81.619-22.48 22.479-59.021 22.382-81.62-.216-22.597-22.598 33.16-25.8 55.64-48.28 22.479-22.479 3.166-55.721 25.764-33.123Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0C9BAB",
  d: "M-8.763 29.204c-22.598 22.598-22.695 59.14-.216 81.619 22.48 22.479 59.021 22.382 81.62-.216 22.598-22.598-33.16-25.8-55.64-48.28C-5.478 39.848 13.835 6.606-8.763 29.204Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#scoreFrame_svg__d)",
  fillOpacity: 0.6,
  d: "M110.434 79.027c0 31.958-25.77 57.866-57.56 57.866-31.79 0-57.562-25.908-57.562-57.866 0-31.959 41.693 5.204 73.483 5.204 31.79 0 41.639-37.163 41.639-5.204Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#scoreFrame_svg__e)",
  fillOpacity: 0.6,
  d: "M-4.687 79.027c0 31.958 25.77 57.866 57.56 57.866 31.79 0 57.562-25.908 57.562-57.866 0-31.959-41.692 5.204-73.483 5.204-31.79 0-41.64-37.163-41.64-5.204Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "scoreFrame_svg__a",
  x1: 53,
  x2: 53,
  y1: 0,
  y2: 106,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#11B9CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.583,
  stopColor: "#045B65"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#024047"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "scoreFrame_svg__b",
  x1: 53,
  x2: 53,
  y1: 0,
  y2: 106,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8A3FFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6929C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "scoreFrame_svg__d",
  x1: 52.873,
  x2: 52.873,
  y1: 66.057,
  y2: 136.893,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.526,
  stopColor: "#0C9BAB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#024047"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "scoreFrame_svg__e",
  x1: 52.874,
  x2: 52.874,
  y1: 66.057,
  y2: 136.893,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#91EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.526,
  stopColor: "#0C9BAB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#024047"
})))));
export default SvgScoreFrame;